import React from 'react';
import { Hero } from '../components/home/Hero';
import { QuickFacts } from '../components/home/QuickFacts';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { WelcomeWeek } from '../components/welcome/WelcomeWeek';
import { TypicalWeek } from '../components/schedule/TypicalWeek';
import { Mission } from '../components/home/Mission';
import { WelcomeVideo } from '../components/home/WelcomeVideo';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <>
      <Hero data-id="element-546" data-mp="24i3imbgip9pw" />
      <QuickFacts data-id="element-547" data-mp="24hk7pepablld" />
      <UpcomingEvents data-id="element-548" data-mp="24j4swdppls6k" />
      <WelcomeWeek data-id="element-549" data-mp="29gdbugiom08v" />
      <TypicalWeek data-id="element-550" data-mp="29fvibrnem04n" />
      <Mission data-id="element-551" data-mp="29fc1ke9hphs7" />
      <WelcomeVideo data-id="element-552" data-mp="29etu0lhdnh4z" />
      <FinalCta data-id="element-553" data-mp="29ihnxlqqi5k8" />
    </>;
}